import { useNodeResizeMonitor } from "./useNodeResizeMonitor.ts";
import { useTransformOriginDragMonitor } from "./useTransformOriginDragMonitor.ts";

// Runs the canvas drag monitors (each is a hook that writes drag state to atoms
// and returns nothing); colocated in one null component so they mount together.
export const CanvasDragMonitors = () => {
  useNodeResizeMonitor();
  useTransformOriginDragMonitor();
  return null;
};
